// extracted by mini-css-extract-plugin
export default {"samplingEventButton":"SamplingEventActions_samplingEventButton__wLEDP"};